import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = ["fill"]

import { withDefaults } from 'vue';

    interface IProps {
        color?: string;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PersonCheckIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: _ctx.color || '#8897a8'
  }, [
    _createElementVNode("path", {
      d: "M702-480 560-622l57-56 85 85 170-170 56 57-226 226Zm-342 0q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Z",
      fill: _ctx.color || '#8897a8'
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})